(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aathi-category-showcase"] && !Shopify.designMode) return;
  try {
    
class AathiCollectionMotion extends HTMLElement {
 connectedCallback(){
  const rail=this.querySelector('.aathi-category__grid'),button=this.querySelector('.aathi-collection-toggle');
  if(!rail||!button||rail.children.length<2)return;
  const originals=[...rail.children], events=new AbortController(), reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let prepared=false;
  const prepare=()=>{if(prepared)return;prepared=true;const fragment=document.createDocumentFragment();
  originals.forEach(card=>{const clone=card.cloneNode(true);clone.dataset.duplicate='true';clone.tabIndex=-1;clone.removeAttribute('data-shopify-editor-block');clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a,button').forEach(a=>a.tabIndex=-1);fragment.append(clone);});
  rail.append(fragment);};
  let paused=reduced.matches, last=0, position=0, hold=0, frame=0, visible=false, cycle=0;
  const listen=(target,event,fn)=>target.addEventListener(event,fn,{signal:events.signal});
  const update=()=>{button.textContent=paused?button.dataset.play:button.dataset.pause;schedule();};
  button.hidden=false;update();
  listen(button,'click',()=>{paused=!paused;update();});
  listen(reduced,'change',()=>{paused=reduced.matches;update();});
  ['pointerdown','pointermove','wheel','keydown'].forEach(e=>listen(rail,e,event=>{if(e==='pointermove'&&!event.buttons)return;hold=performance.now()+1800;position=rail.scrollLeft;}));
  function schedule(){
   if(!visible||paused||document.hidden){cancelAnimationFrame(frame);frame=0;last=0;return;}
   if(!frame)frame=requestAnimationFrame(tick);
  }
  function tick(now){
   frame=0;
   const dt=last?Math.min(now-last,50):0;last=now;
   if(now>hold&&!rail.contains(document.activeElement)&&cycle>0){position=(position+dt*0.035)%cycle;rail.scrollLeft=position;}else position=rail.scrollLeft;
   schedule();
  }
  const measure=()=>{cycle=rail.children[originals.length].offsetLeft-rail.children[0].offsetLeft;};
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible){prepare();position=rail.scrollLeft;measure();}schedule();},{rootMargin:'300px 0px'});
  observer.observe(rail);
  const resize=new ResizeObserver(()=>{if(visible)measure();});resize.observe(rail);
  listen(document,'visibilitychange',schedule);
  this.cleanup=()=>{cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();events.abort();rail.querySelectorAll('[data-duplicate]').forEach(n=>n.remove());};
 }
 disconnectedCallback(){this.cleanup?.();}
}
if(!customElements.get('aathi-collection-motion'))customElements.define('aathi-collection-motion',AathiCollectionMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aathi-promo-banners"] && !Shopify.designMode) return;
  try {
    
class AathiPromoBanners extends HTMLElement{
 connectedCallback(){
  const rail=this.querySelector('.aathi-promo__rail'),toggle=this.querySelector('[data-toggle]'),reduced=matchMedia('(prefers-reduced-motion: reduce)'),events=new AbortController();
  if(!rail||rail.children.length<2)return;
  this.querySelector('.aathi-promo__controls').hidden=false;
  let paused=reduced.matches,last=Date.now();
  const label=()=>{toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;};label();
  const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:events.signal});
  const advance=dir=>{const i=Math.round(rail.scrollLeft/rail.clientWidth),next=(i+dir+rail.children.length)%rail.children.length;rail.scrollTo({left:next*rail.clientWidth,behavior:reduced.matches?'instant':'smooth'});last=Date.now();};
  on(toggle,'click',()=>{paused=!paused;label();last=Date.now();});
  on(reduced,'change',()=>{paused=reduced.matches;label();});
  on(this.querySelector('[data-prev]'),'click',()=>advance(-1));on(this.querySelector('[data-next]'),'click',()=>advance(1));
  ['pointerdown','wheel','keydown','focusin'].forEach(e=>on(rail,e,()=>{last=Date.now();}));
  let visible=false;
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;});observer.observe(this);
  const timer=setInterval(()=>{if(visible&&!paused&&!document.hidden&&!rail.contains(document.activeElement)&&Date.now()-last>4500)advance(1);},500);
  this.cleanup=()=>{clearInterval(timer);observer.disconnect();events.abort();};
 }
 disconnectedCallback(){this.cleanup?.();}
}
if(!customElements.get('aathi-promo-banners'))customElements.define('aathi-promo-banners',AathiPromoBanners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aathi-testimonials"] && !Shopify.designMode) return;
  try {
    
class AathiReviewMarquee extends HTMLElement {
 connectedCallback(){
  const rail=this.querySelector('.aathi-testimonials__rail'),button=this.querySelector('.aathi-testimonials__toggle');
  if(!rail||!button||rail.children.length<2)return;
  const originals=[...rail.children], events=new AbortController(), reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let prepared=false;
  const prepare=()=>{if(prepared)return;prepared=true;const fragment=document.createDocumentFragment();
  originals.forEach(card=>{const clone=card.cloneNode(true);clone.dataset.duplicate='true';clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a,button').forEach(a=>a.tabIndex=-1);fragment.append(clone);});
  rail.append(fragment);};
  let paused=reduced.matches, last=0, position=0, hold=0, frame=0, visible=false, cycle=0;
  const listen=(target,event,fn)=>target.addEventListener(event,fn,{signal:events.signal});
  const update=()=>{button.textContent=paused?button.dataset.play:button.dataset.pause;schedule();};
  button.hidden=false;update();
  listen(button,'click',()=>{paused=!paused;update();});
  listen(reduced,'change',()=>{paused=reduced.matches;update();});
  ['pointerdown','pointermove','wheel','keydown'].forEach(e=>listen(rail,e,event=>{if(e==='pointermove'&&!event.buttons)return;hold=performance.now()+1800;position=rail.scrollLeft;}));
  function schedule(){
   if(!visible||paused||document.hidden){cancelAnimationFrame(frame);frame=0;last=0;return;}
   if(!frame)frame=requestAnimationFrame(tick);
  }
  function tick(now){
   frame=0;
   const dt=last?Math.min(now-last,50):0;last=now;
   if(now>hold&&!rail.contains(document.activeElement)&&cycle>0){position=(position+dt*0.035)%cycle;rail.scrollLeft=position;}else position=rail.scrollLeft;
   schedule();
  }
  const measure=()=>{cycle=rail.children[originals.length].offsetLeft-rail.children[0].offsetLeft;};
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible){prepare();position=rail.scrollLeft;measure();}schedule();},{rootMargin:'300px 0px'});
  observer.observe(rail);
  const resize=new ResizeObserver(()=>{if(visible)measure();});resize.observe(rail);
  listen(document,'visibilitychange',schedule);
  this.cleanup=()=>{cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();events.abort();rail.querySelectorAll('[data-duplicate]').forEach(n=>n.remove());};
 }
 disconnectedCallback(){this.cleanup?.();}
}
if(!customElements.get('aathi-review-marquee'))customElements.define('aathi-review-marquee',AathiReviewMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aathi-zodiac-strip"] && !Shopify.designMode) return;
  try {
    
class AathiZodiacMotion extends HTMLElement {
 connectedCallback(){
  const rail=this.querySelector('.aathi-zodiac__rail'),button=this.querySelector('.aathi-zodiac-toggle');
  if(!rail||!button||rail.children.length<2)return;
  const originals=[...rail.children], events=new AbortController(), reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let prepared=false;
  const prepare=()=>{if(prepared)return;prepared=true;const fragment=document.createDocumentFragment();
  originals.forEach(card=>{const clone=card.cloneNode(true);clone.dataset.duplicate='true';clone.tabIndex=-1;clone.removeAttribute('data-shopify-editor-block');clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a,button').forEach(a=>a.tabIndex=-1);fragment.append(clone);});
  rail.append(fragment);};
  let paused=reduced.matches, last=0, position=0, hold=0, frame=0, visible=false, cycle=0;
  const listen=(target,event,fn)=>target.addEventListener(event,fn,{signal:events.signal});
  const update=()=>{button.textContent=paused?button.dataset.play:button.dataset.pause;schedule();};
  button.hidden=false;update();
  listen(button,'click',()=>{paused=!paused;update();});
  listen(reduced,'change',()=>{paused=reduced.matches;update();});
  ['pointerdown','pointermove','wheel','keydown'].forEach(e=>listen(rail,e,event=>{if(e==='pointermove'&&!event.buttons)return;hold=performance.now()+1800;position=rail.scrollLeft;}));
  function schedule(){
   if(!visible||paused||document.hidden){cancelAnimationFrame(frame);frame=0;last=0;return;}
   if(!frame)frame=requestAnimationFrame(tick);
  }
  function tick(now){
   frame=0;
   const dt=last?Math.min(now-last,50):0;last=now;
   if(now>hold&&!rail.contains(document.activeElement)&&cycle>0){position=(position+dt*0.025)%cycle;rail.scrollLeft=position;}else position=rail.scrollLeft;
   schedule();
  }
  const measure=()=>{cycle=rail.children[originals.length].offsetLeft-rail.children[0].offsetLeft;};
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible){prepare();position=rail.scrollLeft;measure();}schedule();},{rootMargin:'300px 0px'});
  observer.observe(rail);
  const resize=new ResizeObserver(()=>{if(visible)measure();});resize.observe(rail);
  listen(document,'visibilitychange',schedule);
  this.cleanup=()=>{cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();events.abort();rail.querySelectorAll('[data-duplicate]').forEach(n=>n.remove());};
 }
 disconnectedCallback(){this.cleanup?.();}
}
if(!customElements.get('aathi-zodiac-motion'))customElements.define('aathi-zodiac-motion',AathiZodiacMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
